import { createStore } from 'vuex'
import app from './modules/app'
import mental from '@/views/module-mental-health/store' //心理健康
import getters from "./getters"
import createPersistedState from 'vuex-persistedstate'
export default createStore({
  getters,
  modules: {
    app,mental
  },
  plugins:[
    createPersistedState({
      key:'mine',
      paths:['app','mental']
    })
  ]
})
